import { useEffect, useState } from "react";
import apiClient from "../api/apiClient";
import { CompetencyType } from "./useCaptureSelPulse";

interface CompetencyScore {
  original_baseline: number;
  latest_adult_score: number;
  latest_adult_date: string;
  current_signal: number;
  is_capped: boolean;
  next_decay_event: string;
}

type Competencies = Record<CompetencyType, CompetencyScore>;

interface SelScoreData {
  _id: string;
  userId: string;
  schoolHash: string;
  classId: string;
  global_next_decay: string;
  last_updated: string;
  competencies: Partial<Competencies>;
}

interface UseFetchSelScoresReturn {
  loading: boolean;
  error: string | null;
  data: SelScoreData | null;
  refetch: () => void;
}

const useFetchSelScores = (
  schoolHash: string,
  classId: string,
  userId: string
): UseFetchSelScoresReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<SelScoreData | null>(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiClient.get(
        `/currentSelScore/student/${schoolHash}/${classId}/${userId}`
      );
      setData(res.data.data);
    } catch (err: any) {
      setError(err?.response?.data?.message || "Failed to fetch SEL scores");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [schoolHash, classId, userId]);

  return { loading, error, data, refetch: fetchData };
};

export default useFetchSelScores;
